export const FETCH_BACKLINKS_OVERVIEW_IN_PROGRESS = "FETCH_BACKLINKS_OVERVIEW_IN_PROGRESS";
export const FETCH_BACKLINKS_OVERVIEW_SUCCESS = "FETCH_BACKLINKS_OVERVIEW_SUCCESS";
export const FETCH_BACKLINKS_OVERVIEW_FAILED = "FETCH_BACKLINKS_OVERVIEW_FAILED";

export const FETCH_BACKLINKS_IN_PROGRESS = "FETCH_BACKLINKS_IN_PROGRESS";
export const FETCH_BACKLINKS_SUCCESS = "FETCH_BACKLINKS_SUCCESS";
export const FETCH_BACKLINKS_FAILED = "FETCH_BACKLINKS_FAILED";

export const FETCH_REFERRING_DOMAINS_IN_PROGRESS = "FETCH_REFERRING_DOMAINS_IN_PROGRESS";
export const FETCH_REFERRING_DOMAINS_SUCCESS = "FETCH_REFERRING_DOMAINS_SUCCESS";
export const FETCH_REFERRING_DOMAINS_FAILED = "FETCH_REFERRING_DOMAINS_FAILED";

export const FETCH_TOP_ANCHORS_IN_PROGRESS = "FETCH_TOP_ANCHORS_IN_PROGRESS";
export const FETCH_TOP_ANCHORS_SUCCESS = "FETCH_TOP_ANCHORS_SUCCESS";
export const FETCH_TOP_ANCHORS_FAILED = "FETCH_TOP_ANCHORS_FAILED";

export const FETCH_TLD_DISTRIBUTION_IN_PROGRESS = "FETCH_TLD_DISTRIBUTION_IN_PROGRESS";
export const FETCH_TLD_DISTRIBUTION_SUCCESS = "FETCH_TLD_DISTRIBUTION_SUCCESS";
export const FETCH_TLD_DISTRIBUTION_FAILED = "FETCH_TLD_DISTRIBUTION_FAILED";

export const FETCH_TOP_COUNTRIES_IN_PROGRESS = "FETCH_TOP_COUNTRIES_IN_PROGRESS";
export const FETCH_TOP_COUNTRIES_SUCCESS = "FETCH_TOP_COUNTRIES_SUCCESS";
export const FETCH_TOP_COUNTRIES_FAILED = "FETCH_TOP_COUNTRIES_FAILED";
